export const osOptions = [
	{ label: 'Android', value: 1 },
	{ label: 'iOS', value: 2 },
	{ label: 'HarmonyOS', value: 3 },
	{ label: '其它', value: 0 },
];

export const AllColumns = [
	{
		key: 'date',
		label: '日期',
		selectedValue: [],
		dataLevels: '2',
		children: [
			[{value: 'dt', label: '日期', dataLevels: '1'}]
		]
	},
	{
		key: 'os',
		label: '操作系统',
		selectedValue: [],
		children: [
			[
				{
					value: 'os',
					label: '操作系统'
				},
			],
		],
	},
	{
		key: 'media',
		label: '媒体信息',
		selectedValue: [],
		dataLevels: ['1', '2'],
		children: [
			[
				{
					value: 'media_name',
					label: '媒体名称',
					dataLevels: '1',
				},
				{
					value: 'media_id',
					label: '媒体ID',
					dataLevels: '1',
				},
			],
			[
				{
					value: 'qunion_adslot_name',
					label: '代码位名称',
					dataLevels: '2',
				},
				{
					value: 'adslot_id',
					label: '代码位ID',
					dataLevels: '2',
				},
			],
		],
	},
	// {
	//   key: 'incomeSource',
	//   label: '收入来源',
	//   selectedValue: [],
	//   dataLevels: '3',
	//   children: [
	//     [
	//       {
	//         value: 'income_type',
	//         label: '收入类型',
	//       },
	//     ],
	//   ],
	// },
	{
		key: 'income',
		label: '收入',
		selectedValue: [],
		children: [
			[
				{
					value: 'income',
					label: '预估收入',
					sort: true,
					toolTip: '所选日期对应的收入，该收入为预估数据，最终收入以结算为准'
				},
			],
		],
	},
	{
		key: 'request',
		label: '广告请求&填充',
		selectedValue: [],
		children: [
			[
				{
					value: 'request',
					label: '请求',
					sort: true,
					toolTip: '广告有效请求次数'
				},
				{
					value: 'fill',
					label: '填充',
					sort: true,
					toolTip: '广告有效填充次数'
				},
				{
					value: 'fill_ratio',
					label: '填充率',
					sort: true,
					toolTip: '填充率=填充/请求*100%'
				},
				{
					value: 'imp_ratio',
					label: '展示率',
					sort: true,
					toolTip: '广告展示率=展示/填充*100%'
				}
			],
		],
	},
	{
		key: 'detail',
		label: '广告展点消',
		selectedValue: [],
		children: [
			[
				{
					value: 'show',
					label: '广告展示量',
					sort: true,
					toolTip: '有效广告展示次数，不包含重复展示、超时展示'
				},
				{
					value: 'click',
					label: '点击',
					sort: true,
					toolTip: '有效点击次数，不包含重复点击'
				},
			],
			[
				{
					value: 'cpm',
					label: 'cpm',
					sort: true,
					toolTip: 'cpm=预估收入/广告展示量*1000'
				},
				{
					value: 'click_ratio',
					label: '点击率',
					sort: true,
					toolTip: '点击率=点击/广告展示量*100%'
				},
			],
			[
				{
					value: 'avg_click_price',
					label: '点击单价',
					sort: true,
					toolTip: '点击单价=预估收入/点击'
				},
			],
		],
	}
];